/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuditTrailBase
 */
export interface AuditTrailBase {
    /**
     * 
     * @type {string}
     * @memberof AuditTrailBase
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof AuditTrailBase
     */
    valueOriginal?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditTrailBase
     */
    createdBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof AuditTrailBase
     */
    timeInterval: Date;
}

export function AuditTrailBaseFromJSON(json: any): AuditTrailBase {
    return AuditTrailBaseFromJSONTyped(json, false);
}

export function AuditTrailBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditTrailBase {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
        'valueOriginal': !exists(json, 'valueOriginal') ? undefined : json['valueOriginal'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'timeInterval': (new Date(json['timeInterval'])),
    };
}

export function AuditTrailBaseToJSON(value?: AuditTrailBase | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'valueOriginal': value.valueOriginal,
        'createdBy': value.createdBy,
        'timeInterval': (value.timeInterval.toISOString()),
    };
}


